<template>
  <transition
    name="fade-content"
    appear
    mode="out-in"
  >
    <div class="landing-page">
      <div class="landing-page__wrapper">
        <banner />
      </div>
      <fastSearch />
      <div class="general-background__first">
        <worldwide />
        <reviews />
      </div>
      <faq />
      <questions />
    </div>
  </transition>
</template>

<script>
import banner from '@/components/landing/banner';
import questions from '@/components/landing/questions';
import worldwide from '@/components/landing/worldwide';
import faq from '@/components/landing/faq';
import fastSearch from '@/components/landing/fastSearch';
import reviews from '@/components/landing/reviews';
import queryString from 'query-string';

export default {
  name: 'Landing',
  components: {
    fastSearch,
    questions,
    worldwide,
    faq,
    banner,
    reviews,
  },
  beforeMount() {
    const { location: { search } } = window;
    const parsed = queryString.parse(search);
    if (Object.keys(parsed).length) {
      const {
        utm_campaign: utmCampaign, utm_content: utmContent, utm_medium: utmMedium, utm_source: utmSource,
        utm_term: utmTerm,
      } = parsed;
      const isUtm = utmCampaign !== undefined || utmContent !== undefined || utmMedium !== undefined
          || utmSource !== undefined || utmTerm !== undefined;
      const utm = isUtm
        ? {
          utm_campaign: utmCampaign,
          utm_content: utmContent,
          utm_medium: utmMedium,
          utm_source: utmSource,
          utm_term: utmTerm,
        }
        : undefined;
      sessionStorage.setItem('utm', JSON.stringify(utm));
    }
  },
};
</script>

<style scoped lang="scss">
@import "../sass/variables";
@import "../sass/mixins";

.general-background {
  &__first {
    background: url('../assets/images/landing/about-1.png') 100% 41% no-repeat;
  }
}

.landing-page {

  &__wrapper {
    background-image: url('../assets/images/banner-bg.png');
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: 100% 36px;
  }
}

@include desktop-max {
  .landing-page {
    &__wrapper {
      background-position: 100% 2px;
    }
  }
}

@include tablet-landscape {
  .landing-page {
    &__wrapper {
      background-size: inherit;
      background-position: 100% 30px;
    }
  }

  .landing-header-menu {
    &__item {
      span {
        &:after {
          bottom: -21px;
        }
      }
    }
  }
}

@include tablet-portrait {
  .landing-page {
    &__wrapper {
      background-position: 100% 2.5%;
    }
  }

  .general-background {
    &__first {
      background-image: none;
    }
  }
}

@include mobile {
  .landing-page {
    &__wrapper {
      background-size: cover;
      background-position: 0 0;
    }
  }
}
</style>
